
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-eu/products/assets",
      function () {
        return require("private-next-pages/en-eu/products/assets.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-eu/products/assets"])
      });
    }
  